
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"22","height":"22","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M19 0H3a3 3 0 00-3 3v16a3 3 0 003 3h16a3 3 0 003-3V3a3 3 0 00-3-3zm-4.85 11.71l-4.88 4.88a1.002 1.002 0 01-1.639-.325 1 1 0 01.219-1.095L12 11 7.85 6.83a1.004 1.004 0 111.42-1.42l4.88 4.88a1.002 1.002 0 010 1.42z","fill":"url(#tap_icon_svg__paint0_linear_861_50511)"}}),_c('defs',[_c('linearGradient',{attrs:{"id":"tap_icon_svg__paint0_linear_861_50511","x1":"11","y1":"0","x2":"11","y2":"22","gradientUnits":"userSpaceOnUse"}},[_c('stop',{attrs:{"stop-color":"#E0E0E0"}}),_c('stop',{attrs:{"offset":"1","stop-color":"#E0E0E0"}})])])])
          )
        }
      }
    